// extracted by mini-css-extract-plugin
export default {"contant":"Dental_contant__sci-8","text__left":"Dental_text__left__7qID2","text":"Dental_text__-le9n","btn":"Dental_btn__FGqwh"};